import React from 'react';
import { Card, Table, Avatar, Typography } from 'antd';

const { Text } = Typography;

const TopUsers = ({ data, loading }) => {
  const columns = [
    {
      title: 'User',
      key: 'user',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar style={{ marginRight: 12 }}>
            {record.display_name ? record.display_name.charAt(0).toUpperCase() : ''}
          </Avatar>
          <div>
            <Text strong>{record.display_name}</Text><br/>
            <Text type="secondary">{record.email}</Text>
          </div>
        </div>
      ),
    },
    {
      title: 'Total Actions',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
    },
  ];

  return (
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey="user_id"
      />
  );
};

export default TopUsers;
